<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-account-dialog bv-domain-rules-dialog"
  [title]="'customize' | i18n"
>
  <ng-container bitDialogContent>
    <bit-form-field class="bv-mat-field tw-w-full">
      <bit-label>{{ "domainName" | i18n }}</bit-label>
      <input bitInput formControlName="domain" appAutofocus />
    </bit-form-field>
  </ng-container>

  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      <div class="bv-account-dialog__footer-start">
        <button
          type="button"
          class="bv-account-dialog__icon-btn"
          [attr.aria-label]="'delete' | i18n"
          (click)="deleteDomain()"
        >
          <span class="bv-account-dialog__icon-btn__trash" aria-hidden="true"></span>
        </button>
      </div>
      <div class="bv-account-dialog__footer-end">
        <button
          bitButton
          bitFormButton
          type="button"
          buttonType="secondary"
          class="bv-account-dialog__cancel-btn"
          bitDialogClose
        >
          {{ "cancel" | i18n }}
        </button>
        <button
          bitButton
          bitFormButton
          type="submit"
          buttonType="primary"
          class="bv-account-dialog__save-btn"
        >
          {{ "save" | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
</form>
